<template>
    <div>
        <b-row>
            <b-col cols="12" sm="12" md="6">
                <b-input
                    placeholder="Enter Permission"
                    v-model="name"
                    class="perm_input"
                />
            </b-col>
            <b-col cols="12" sm="12" md="6">
                <multiselect
                    class="perm_input"
                    :options="methods"
                    placeholder="Select Method"
                    label="value"
                    track-by="value"
                    :multiple="false"
                    v-model="action"
                ></multiselect>
            </b-col>

            <b-col cols="12" sm="12" md="12">
                <b-input
                    placeholder="Enter Resource URL"
                    v-model="resource"
                    class="perm_input"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col class="text-center button-group-wrapper">
                <eb-button
                    class="btn btn-cancel"
                    classic="btn-danger"
                    text="Cancel"
                    @click="resetForm"
                ></eb-button>
                <eb-button
                    class="btn btn-save"
                    classic="btn-primary"
                    text="Save"
                    @click="createNewPerm"
                ></eb-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import ebButton from "@/components/FormElements/Button.vue";

export default {
    name: "CreatePermission",
    components: {
        ebButton,
    },
    data() {
        return {
            action: null,
            resource: "",
            name: "",
            methods: [
                {
                    label: "GET",
                    value: "GET",
                },
                {
                    label: "POST",
                    value: "POST",
                },
                {
                    label: "PUT",
                    value: "PUT",
                },
                {
                    label: "DELETE",
                    value: "DELETE",
                },
            ],
        };
    },
    methods: {
        clearRefresh() {
            this.name = "";
            this.action = "";
            this.resource = "";
        },
        createNewPerm() {
            if (this.name != "" && this.action != "" && this.resource != "") {
                this.$emit("newPermission", {
                    name: this.name,
                    action: this.action.value,
                    resource: this.resource,
                });
            } else {
                this.$swal({
                    title: "Error",
                    text: "Please fill all Fields.",
                    type: "error",
                });
            }
        },
        resetForm() {
            this.$emit("newPerm");
        },
    },
};
</script>

<style scoped>
.perm_input {
    height: 40px;
    margin-bottom: 20px;
}

.button-group-wrapper {
    text-align: center;
}

.btn-cancel {
    width: 30%;
    margin: 30px;
}

.btn-save {
    width: 30%;
}

@media (max-width: 767.98px) {
    .button-group-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1rem;
    }

    .btn-cancel,
    .btn-save {
        width: 100%;
        margin: 0;
    }
}
</style>
